import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { NavMenuItem } from "models/propTypes/pageLayoutPropTypes";
import { BusinessUnitFormContainerProps } from "models/propTypes/businessUnitPropTypes";
//#endregion
//#region components
import { PageLayouts, ViewPanel } from "components/common";
import BusinessUnitFormContainer from "./forms/businessUnitFormContainer";
//#endregion
import cssExports from "theme/styles/main.module.scss";

type WrapperProps = BusinessUnitFormContainerProps & {
  navKey?: string;
  enableDelayedScrollToTarget?: boolean;
};

const BusinessUnitFormNavWrapper: ForwardRefRenderFunction<FormHandles, WrapperProps> = (
  props,
  ref
) => {
  const { navKey = "businessUnit", enableDelayedScrollToTarget = true, ...formContainerProps } = props;

  const BUFormNavContent: React.FC<{ setNavLayoutSections?: any; title?: any }> = (p) => (
    <ViewPanel className={cssExports.wizardOuter}>
      <BusinessUnitFormContainer ref={ref} {...(formContainerProps as any)} {...p} />
    </ViewPanel>
  );

  const navItems: NavMenuItem[] = [
    {
      navKey,
      content: <BUFormNavContent />,
    },
  ];

  return <PageLayouts.NavigationLayout navItems={navItems} enableDelayedScrollToTarget={enableDelayedScrollToTarget} />;
};

export default forwardRef(BusinessUnitFormNavWrapper);


